import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {categoryTableReady,rowsPerPageState,searchTextState,paginationState,categoryIdForAction,previousFilterCity} from '../redux/categories'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/categoryTable.css'


import {Cities} from '../../../common/DropDowns/index'


import * as Helpers from '../../../common/helpers'


function filterUnwantedData(categoriesData) {
    let array = []
    if (categoriesData && categoriesData.data && categoriesData.data.list) {
        array = categoriesData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.up_id = lineData.up_id ? lineData.up_id : "NA"
            newLineData.name = lineData.name ? lineData.name : "NA"
            newLineData.status = lineData.status ? lineData.status : "NA"
            newLineData.city = lineData.city && lineData.city.name ? lineData.city.name : "NA"
            newArray[i] = newLineData
        }
    }
    return newArray
}


class CategoriesTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            categoryData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_city:"",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(categoryTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.CATEGORIES_TABLE))
        this.props.dispatch(subHeaderDataUpdate())


        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

            let previousFilterCity=""

         if (this.props.categories && this.props.categories.previousFilterCity && this.props.categories.previousFilterCity!==undefined) {
            previousFilterCity=this.props.categories.previousFilterCity
         }         

         if(previousFilterCity===undefined || previousFilterCity===null || previousFilterCity===""){
            previousFilterCity=""
         }
         
         this.setState({
              filter_city:previousFilterCity,
         },() => {
            this.getCategoriesData();
        });

        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getCategoriesData = () => {
        apiService.getCategoriesData(this.state.filter_city)
            .then(categoriesData => {
                if (categoriesData && this.isComponentMounted) {
                    this.validateBuildNumber(categoriesData)
                    if (categoriesData.status === "SUCCESS") {
                        let array = filterUnwantedData(categoriesData), pageNo = 1
                        if (this.props.categories && this.props.categories.previousPaginationValue) {
                            pageNo = this.props.categories.previousPaginationValue
                        }
                        this.setState({
                            categoryData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: categoriesData.reason ? categoriesData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(categoryTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(categoryTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

     cityChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterCity(""))
             this.setState({
                filter_city :"",            
            })
        }else{
            this.props.dispatch(previousFilterCity(data.value))
            this.setState({
                filter_city :data.value,            
            })
        }
    }


    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.categories && this.props.categories.previousRowsPerPageValue) {
            value = this.props.categories.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   
                {/*
                   {(() =>{

                    if(Helpers.checkPrivileges("/dashboard/categories/addEdit",this.props.user)){
                    return(
                        <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                            <button className="btn btn-primary button-custom"
                                    style={{ marginLeft: "5px" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.props.dispatch(categoryIdForAction())
                                        this.props.history.push("/dashboard/categories/addEdit")
                                    }}>
                                    Add
                                </button>
                         </div>

                        )
                      }
                   })()}

                */}
                   

                   
                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <Cities cityChange={this.cityChange} selectedValue={this.state.filter_city} /> 
                    </div>
                    </div>

                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredCategoriesList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.categoryData.length>=(this.props.categories.previousPaginationValue*this.props.categories.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.categories.previousPaginationValue*this.props.categories.previousRowsPerPageValue)-this.props.categories.previousRowsPerPageValue+1} to {this.props.categories.previousPaginationValue*this.props.categories.previousRowsPerPageValue} of {this.state.categoryData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.categories.previousPaginationValue*this.props.categories.previousRowsPerPageValue)-this.props.categories.previousRowsPerPageValue+1} to {this.state.categoryData.length} of {this.state.categoryData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredCategoriesList = () => {
       
        this.props.dispatch(categoryTableReady(false))
        this.resetSearchAndPagination()
        this.getCategoriesData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getCategoriesData()
        this.props.dispatch(categoryTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }


    resetFilterValues = () => {
        this.props.dispatch(categoryTableReady(false))
        this.setState({
            filter_city:"",
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterCity(""))

            this.getCategoriesData()
        });

        
    }

    actionButtonsCreator = (cell, row) => {
        let editButton =""


        if(Helpers.checkPrivileges("/dashboard/categories/addEdit",this.props.user)){
        
            editButton=<button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editCategory(row)
                }}>
                Edit
            </button>
        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.categories && this.props.categories.previousPaginationValue
            && this.props.categories.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editCategory = (row) => {
        if (row && row.id) {
            this.props.dispatch(categoryIdForAction(row.id))
            this.props.history.push("/dashboard/categories/addEdit")
        } else {
            this.dialog.show({
                title: "Brand Identification number not found",
                body: 'Brand id is not available, So not able edit category',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.categories && this.props.categories.previousRowsPerPageValue) {
            sizeperPage = this.props.categories.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="categories-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.categoryData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>
                    

                     {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                        
                    <TableHeaderColumn
                        dataField="up_id"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Urbanpiper Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="status"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Status
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="city"
                        dataSort={true}
                        //width="90"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        City
                    </TableHeaderColumn>
                    
                {/*
                     <TableHeaderColumn
                        //width="110"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                */}
                
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        categories: state.categories
    }
}

export default connect(mapStateToProps)(withRouter(CategoriesTable))


// WEBPACK FOOTER //
// ./src/modules/Categories/Components/CategoriesTable.js